import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './units/api';
import './plugins/element.js'
import vueCookie from './plugins/cookie'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './units/dialog'

Vue.use(VueQuillEditor);
Vue.config.productionTip = false
Vue.prototype.$api = api;
Vue.prototype.$cookie = vueCookie;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
